export function isNullish(value: unknown): value is null | undefined {
    return value === null || value === undefined
}

export function isNotNullish<T>(value: T): value is NonNullable<T> {
    return !isNullish(value)
}

export function booleanFromURLParam(value: string | null, defaultValue: boolean): boolean {
    if (value === 'true') {
        return true
    }
    if (value === 'false') {
        return false
    }
    return defaultValue
}

export const isStringWithContent = (value: unknown): value is string => typeof value === 'string' && value.trim() !== ''
